export default __webpack_public_path__ + "static/media/12.662c849d.jpg";